import { cn } from "@/lib/utils"
import classes from "./closeIcon.module.css"

const CloseIcon = (props: { closeClassName?: string }) => {
  const { closeClassName } = props

  return <div className={cn(classes.root, closeClassName)} />
}

export default CloseIcon
